module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('progressbar-logo-icon')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "button is-black",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("I understand")])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large",
    attrs: {
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Sorry, we are temporarily closed 😭")]), _vm._v(" "), _c('br'), _vm._v("\n              Corona crisis hit us, however we are doing our best to reopen soon!\n            ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2700d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CloseModal.vue
// module id = 90
// module chunks = 24